<template>
  <b-container fluid>
    <v-app-bar
      app
      color="#f8f3eb"
      sticky
      v-if="editable"
      style="min-height: 50px; max-height: 50px"
    >
      <v-toolbar-title
        :class="{
          toolbarTitleDesktop: !isDesktop,
          toolbarTitleMobile: isDesktop,
        }"
      >
        <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
          <div class="menubar">
            <button class="menubar__button" @click="commands.undo">
              <label><v-icon>mdi-undo</v-icon></label>
            </button>
            <button class="menubar__button" @click="commands.redo">
              <label><v-icon>mdi-redo</v-icon></label>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.bold() }"
              @click="commands.bold"
            >
              <label><v-icon>mdi-format-bold</v-icon></label>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.italic() }"
              @click="commands.italic"
            >
              <label><v-icon>mdi-format-italic</v-icon></label>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.strike() }"
              @click="commands.strike"
            >
              <label><v-icon>mdi-format-strikethrough</v-icon></label>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.underline() }"
              @click="commands.underline"
            >
              <label><v-icon>mdi-format-underline</v-icon></label>
            </button>

            <button class="menubar__button">
              <label for="input-file"><v-icon>mdi-image</v-icon></label>
              <input
                type="file"
                id="input-file"
                multiple="multiple"
                style="display: none"
                @change="onFileChange"
              />
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.code() }"
              @click="commands.code"
            >
              <label><v-icon>mdi-code-tags</v-icon></label>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.paragraph() }"
              @click="commands.paragraph"
            >
              <label><v-icon>mdi-format-paragraph</v-icon></label>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.heading({ level: 1 }) }"
              @click="commands.heading({ level: 1 })"
            >
              <label><v-icon>mdi-format-header-1</v-icon></label>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.heading({ level: 2 }) }"
              @click="commands.heading({ level: 2 })"
            >
              <label><v-icon>mdi-format-header-2</v-icon></label>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.heading({ level: 3 }) }"
              @click="commands.heading({ level: 3 })"
            >
              <label><v-icon>mdi-format-header-3</v-icon></label>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.bullet_list() }"
              @click="commands.bullet_list"
            >
              <label><v-icon>mdi-order-bool-ascending</v-icon></label>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.ordered_list() }"
              @click="commands.ordered_list"
            >
              <label><v-icon>mdi-order-numeric-ascending</v-icon></label>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.blockquote() }"
              @click="commands.blockquote"
            >
              <label><v-icon>mdi-format-quote-close</v-icon></label>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.code_block() }"
              @click="commands.code_block"
            >
              <label><v-icon>mdi-code-not-equal-variant</v-icon></label>
            </button>
            <button
              class="menubar__button"
              @click="
                commands.createTable({
                  rowsCount: 1,
                  colsCount: 1,
                  withHeaderRow: false,
                })
              "
            >
              <label><v-icon>mdi-table-large-plus</v-icon></label>
            </button>
            <span v-if="isActive.table()">
              <button class="menubar__button" @click="commands.deleteTable">
                <label><v-icon>mdi-table-large-delete</v-icon></label>
              </button>
              <button class="menubar__button" @click="commands.addColumnBefore">
                <label><v-icon>mdi-table-column-plus-before</v-icon></label>
              </button>
              <button class="menubar__button" @click="commands.addColumnAfter">
                <label><v-icon>mdi-table-column-plus-after</v-icon></label>
              </button>
              <button class="menubar__button" @click="commands.deleteColumn">
                <label><v-icon>mdi-table-column-remove</v-icon></label>
              </button>
              <button class="menubar__button" @click="commands.addRowBefore">
                <label><v-icon>mdi-table-row-plus-before</v-icon></label>
              </button>
              <button class="menubar__button" @click="commands.addRowAfter">
                <label><v-icon>mdi-table-row-plus-after</v-icon></label>
              </button>
              <button class="menubar__button" @click="commands.deleteRow">
                <label><v-icon>mdi-table-row-remove</v-icon></label>
              </button>
              <button class="menubar__button" @click="commands.toggleCellMerge">
                <label><v-icon>mdi-table-merge-cells</v-icon></label>
              </button>
            </span>
          </div>
        </editor-menu-bar>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon id="titleIcon" variant="outline-primary" @click="print"
        >mdi-printer</v-icon
      >
      <v-icon
        id="titleIcon"
        v-show="editableUse"
        variant="outline-primary"
        @click="editDetail"
        >mdi-pencil</v-icon
      >
      <v-icon
        id="titleIcon"
        v-show="editableUse"
        variant="outline-primary"
        size="sm"
        @click="deleteDetail"
        >mdi-delete</v-icon
      >
      <v-icon
        id="titleIcon"
        v-show="editable"
        variant="outline-primary"
        size="sm"
        @click="editDetailCancel"
        >mdi-cancel</v-icon
      >
      <v-icon
        id="titleIcon"
        v-show="editable"
        variant="outline-primary"
        size="sm"
        @click="saveDetail"
        >mdi-content-save</v-icon
      >
    </v-app-bar>
    <b-card style="max-width: 50rem; margin: auto" align="left">
      <b-card-title>
        <b-row>
          <b-col cols="6" id="titleCol">
            {{ titleFilter }}
          </b-col>
          <b-col cols="6" id="titleCol" style="text-align: end">
            <b-form-checkbox
              v-if="editable && sort !== 'privateBulletinBoard'"
              v-model="radioSelected"
              value="viewOnly"
              >나만보기</b-form-checkbox
            >
            <b-form-checkbox
              v-if="editable && isMemberType === 'ADMIN'"
              v-model="radioSelected2"
              value="true"
              >공지등록</b-form-checkbox
            >
          </b-col>
        </b-row>
        <b-row v-if="!this.$route.query.readOnly">
          <b-col cols="6">
            <b-button
              block
              v-if="!editable && !this.$store.getters.isNew"
              :disabled="isPrevious === null"
              :to="{
                name: sort + 'Detail',
                params: { id: isPrevious, sort: sort },
              }"
              >이전 글</b-button
            >
          </b-col>
          <b-col cols="6">
            <b-button
              block
              v-if="!editable && !this.$store.getters.isNew"
              :disabled="isNext === null"
              :to="{
                name: sort + 'Detail',
                params: { id: isNext, sort: sort },
              }"
              >다음 글</b-button
            >
          </b-col>
        </b-row>
      </b-card-title>
      <b-card-body>
        <div class="editor" id="printArea">
          <div id="editorToolbar" class="toolbar">
            <b-form-input
              id="editorTitle"
              :readonly="!editable"
              v-model="title"
              type="text"
              size="lg"
              placeholder="제목을 입력하세요."
            ></b-form-input>
            <hr class="hr-1" />
          </div>
          <div id="editorContent" style="overflow: auto">
            <editor-content
              id="editorData"
              class="editor__content"
              :editor="editor"
            />
          </div>
        </div>
        <Spinner />
      </b-card-body>
      <b-list-group id="replyGroup" v-if="replyOk">
        <div>
          <b-row style="overflow: auto; white-space: nowrap">
            <b-col style="width: max-content">
              <b-form-input
                v-model="newItems.contents"
                type="text"
                placeholder="새 댓글 남기기."
              />
            </b-col>
            <b-col sm="2" style="width: max-content">
              <b-button variant="outline-primary" v-on:click="createReply"
                ><b-icon icon="plus"
              /></b-button>
            </b-col>
          </b-row>
        </div>
        <hr />
        <div ref="reply" v-for="(item, index) in results" :key="index">
          <b-row id="replyRow">
            <b-col cols="1" class="py-2">
              <v-icon>mdi-subdirectory-arrow-right</v-icon>
            </b-col>
            <b-col cols="7" class="py-2">
              <span style="font-size: 1em; font-weight: 600">{{
                item.contents
              }}</span>
            </b-col>
            <b-col cols="2" class="py-1">
              <span
                style="font-size: 1em; font-weight: 600; white-space: nowrap"
                >{{ item.username }}</span
              >
            </b-col>
            <b-col cols="1" class="py-1">
              <v-icon @click="replyDelete(item.id)">mdi-delete</v-icon>
            </b-col>
          </b-row>
        </div>
      </b-list-group>
    </b-card>

    <!-- URL 링크 모달 -->
    <modal
      name="link-modal"
      :width="modalWidth"
      :height="modalHeight"
      :resizable="true"
      :adaptive="true"
      draggable=".modal-header-draggable"
      :clickToClose="true"
      v-if="selectedLink"
    >
      <div class="modal-header-draggable">
        <h3>{{ selectedLink.title }}</h3>
        <button class="close" @click="closeLinkModal">×</button>
      </div>
      <div class="modal-body">
        <iframe
          :src="selectedLink.url"
          frameborder="0"
          style="width: 100%; height: 100%"
        ></iframe>
      </div>
    </modal>
  </b-container>
</template>

<script>
import printJS from "print-js";
import Spinner from "./Spinner";
import { init, setSnackBarInfo } from "../js/common_function";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import { clearLocalStorage } from "../js/oauth";
import {
  Placeholder,
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Table,
  TableHeader,
  TableCell,
  TableRow,
  Strike,
  Underline,
  History,
} from "tiptap-extensions";
import Doc from "./Doc";
import Image from "./Image";
import Title from "./Title";
import { eventBus } from "../main.js";

export default {
  name: "Detail",
  props: ["id", "sort", "readOnly"],
  components: {
    EditorContent,
    EditorMenuBar,
    Spinner,
    printJS,
  },
  data() {
    return {
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new Image(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Doc(),
          new Title(),
          new Placeholder({
            showOnlyCurrent: false,
            emptyNodeText: (node) => "여기에 내용을 입력하세요.",
          }),
          new Table({
            resizable: true,
          }),
          new TableHeader(),
          new TableCell(),
          new TableRow(),
        ],
        content: "",
      }),
      title: "",
      contents: {
        id: "",
        title: "",
        contents: "",
        auth: "",
        sort: "",
        memberType: "",
      },
      radioSelected: "",
      radioSelected2: false,
      newItems: {
        id: "",
        refId: "",
        contents: "",
        username: "",
      },
      delItems: {
        id: "",
        sort: "",
      },
      link: {
        title: "",
        description: "",
        url: "",
      },
      loginMember: {
        username: "",
        password: "",
      },
      timeoutQuery: null,
      selectedLink: null, // 모달에 표시할 링크 정보
      modalWidth: window.innerWidth * 0.8, // Home.vue 모달 크기 참조
      modalHeight: window.innerHeight * 0.8,
    };
  },
  computed: {
    isPrevious() {
      return this.$store.getters.isPrevious;
    },
    isNext() {
      return this.$store.getters.isNext;
    },
    isDesktop() {
      return !this.$vuetify.breakpoint.mobile;
    },
    editable() {
      this.editor.setOptions({
        editable: this.$store.getters.isEditable,
      });
      return this.$store.getters.isEditable;
    },
    editableUse() {
      return this.$store.getters.isEditableUse;
    },
    results() {
      return this.$store.getters.isReply;
    },
    isMemberType() {
      return this.$store.getters.isMemberType;
    },
    replyOk() {
      return this.$store.getters.isReplyOk;
    },
    titleFilter() {
      const titles = {
        financeBoard: "경제",
        realEstateBoard: "부동산",
        IT: "IT",
        bulletinBoard: "포럼",
        privateBulletinBoard: "소통공간",
        Comment: "감상평",
        Travel: "여행일지",
        humor: "유머",
        Exercise: "운동일지",
        English: "언어학습",
        BongGu: "봉구일지",
        todayIssue: "오늘의이슈",
        siteMap: "사이트맵",
      };
      return titles[this.sort] || "";
    },
  },
  methods: {
    // 링크 클릭 시 모달 열기
    openLinkModal(url) {
      this.selectedLink = {
        title: url, // 기본적으로 URL을 제목으로 사용 (필요 시 커스터마이징 가능)
        url: url,
      };
      this.updateModalSize();
      this.$nextTick(() => {
        this.$modal.show("link-modal");
      });
    },

    // 모달 닫기
    closeLinkModal() {
      this.$modal.hide("link-modal");
      this.selectedLink = null;
    },

    // 모달 크기 업데이트 (Home.vue에서 가져옴)
    updateModalSize() {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isMobile = width <= 768;

      if (isMobile) {
        this.modalWidth = `${Math.round(width * 0.9)}px`;
        this.modalHeight = `${Math.round(height * 0.8)}px`;
      } else {
        this.modalWidth = `${Math.min(800, width * 0.8)}px`;
        this.modalHeight = `${Math.min(600, height * 0.8)}px`;
      }
    },

    sendkakao() {
      Kakao.Share.sendDefault({
        objectType: "feed",
        content: {
          title: this.link.title,
          description: this.link.description,
          imageUrl: "",
          link: {
            mobileWebUrl: this.link.url,
            webUrl: this.link.url,
          },
        },
      });
    },
    print() {
      printJS({ printable: "printArea", type: "html" });
    },
    routine() {
      this.timeoutQuery = setInterval(() => {
        if (this.editor.getHTML().length > 7 || this.title.length > 0) {
          if (this.$store.getters.isNew) {
            localStorage.removeItem("id");
          } else {
            localStorage.setItem("id", this.id);
          }
          localStorage.setItem("title", this.title);
          localStorage.setItem("contents", this.editor.getHTML());

          this.$store.commit(
            "SET_SNACKBAR",
            setSnackBarInfo("자동 저장 되었습니다.")
          );
        }
      }, 30000);
    },
    methodClearInterval() {
      clearInterval(this.timeoutQuery);
    },
    editDetail() {
      this.setAuth();
      this.routine();
      this.editor.view.focused = true;
      this.$store.commit("EDIT_DETAIL");
    },
    editDetailCancel() {
      this.$store.commit("EDIT_DETAIL_CANCEL");
    },
    deleteDetail() {
      this.delItems.id = this.$store.getters.isId;
      this.delItems.sort = this.$store.getters.isSort;
      this.$confirm({
        auth: true,
        message: "Are you sure?",
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm, password) => {
          this.loginMember.username = localStorage.getItem("username");
          this.loginMember.password = password;

          this.$store.dispatch("MATCH_LOGIN", this.loginMember).then((res) => {
            if (confirm && res.data.data === true) {
              this.$store
                .dispatch("BULLETIN_DELETE", this.delItems)
                .then(() => {
                  this.$router.go(-1);
                });
            } else if (confirm && res.data.data == null) {
              this.$store.commit(
                "SET_SNACKBAR",
                setSnackBarInfo("비밀번호가 틀립니다.")
              );
            }
          });
        },
      });
    },
    saveDetail() {
      this.contents.auth = this.radioSelected ? this.radioSelected : "viewAll";
      this.contents.notice = this.radioSelected2;

      this.$store.commit("START_SPINNER");
      this.contents.id = this.id;
      this.contents.title = this.title;
      this.contents.sort = this.sort;
      this.contents.username = localStorage.getItem("username");
      this.contents.contents = this.editor.getHTML();
      init().then(() => {
        this.$store.dispatch("BULLETIN_SAVE", this.contents).then((res) => {
          if (res === true) {
            this.callRepresentPhoto();
            localStorage.removeItem("id");
            localStorage.removeItem("title");
            localStorage.removeItem("contents");
            this.$router.go(-1);
          } else {
            this.$store.commit("END_SPINNER");
          }
        });
      });
    },
    async callRepresentPhoto() {
      const seq = await this.$store.dispatch("IS_REPRE_SEQ");
      if (seq.data[0].repreStartnum + 1 !== seq.data[0].repreLastnum) {
        try {
          for (
            let i = seq.data[0].repreStartnum + 1;
            i <= seq.data[0].repreLastnum;
            i++
          ) {
            const contents = { num: i, file: "" };
            const response = await this.$store.dispatch(
              "IS_CHANGE_REPRESENT_PHOTO",
              contents.num
            );
            if (response.data.length > 0) {
              contents.file = response.data[0].representPhoto;
              contents.start = seq.data[0].repreStartnum + 1;
              contents.end = seq.data[0].repreLastnum;
              this.$store.dispatch("IS_CREATE_AND_SET_IMAGE", contents);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    setAuth() {
      this.radioSelected = this.$store.getters.isContentsAuth;
      this.radioSelected2 = this.$store.getters.isContentsNotice;
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (files.length) {
        for (let i = 0; i < files.length; i++) {
          this.createImage(files[i]);
        }
      }
    },
    createImage(file) {
      const view = this.editor.view;
      const { schema } = view.state;
      const reader = new FileReader();
      const img = document.createElement("img");
      reader.onload = (e) => {
        img.src = e.target.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const MAX_WIDTH = 700;
          let width = img.width;
          let height = img.height;
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
          canvas.width = width;
          canvas.height = height;

          ctx.drawImage(img, 0, 0, width, height);
          const dataurl = canvas.toDataURL("image", 0.1);
          const node = schema.nodes.image.create({ src: dataurl });
          const transaction = view.state.tr.replaceSelectionWith(node);
          view.dispatch(transaction);
        };
      };
      reader.readAsDataURL(file);
    },
    replyDelete(id) {
      this.$axios({
        url: "/api/bulletin/checkReply",
        method: "post",
        data: { id },
        headers: { "token-key": localStorage.getItem("token-key") },
      }).then((res) => {
        if (res.data) {
          this.newItems.id = id;
          this.newItems.refId = this.$store.getters.isThisId;
          this.$store
            .dispatch("DELETE_REPLY", this.newItems)
            .then((response) => {
              this.$store.commit("SET_REPLY", response.data);
              this.$store.commit("SET_THISID", this.$store.getters.isThisId);
              this.newItems.contents = "";
            });
        } else {
          this.$store.commit(
            "SET_SNACKBAR",
            setSnackBarInfo("권한이 없습니다.")
          );
        }
      });
    },
    createReply() {
      this.newItems.refId = this.$store.getters.isThisId;
      this.$store.dispatch("CREATE_REPLY", this.newItems).then((res) => {
        this.$store.commit("SET_REPLY", res.data);
        this.$store.commit("SET_THISID", this.$store.getters.isThisId);
        this.newItems.contents = "";
      });
    },
    checkRightClick() {
      if (["ADMIN", "MANAGER", "USER"].includes(this.isMemberType)) {
        document.body.removeAttribute("oncontextmenu");
        document.body.removeAttribute("onselectstart");
        document.body.removeAttribute("ondragstart");
      } else {
        document.body.setAttribute("oncontextmenu", "return false");
        document.body.setAttribute("onselectstart", "return false");
        document.body.setAttribute("ondragstart", "return false");
      }
    },
  },
  mounted() {
    const Nm = {};
    this.$parent.$parent.$children.map(function (value) {
      if (value.$options._componentTag === "AppBar") {
        value.navTopBar = true;
      }
    });
    this.newItems.contents = "";
    try {
      if (this.id !== "new" && this.sort) {
        this.$axios({
          url: this.$config.baseBulletinAppURL + "/checkBulletinList",
          method: "post",
          data: { id: this.id, sort: this.sort },
          headers: { "token-key": localStorage.getItem("token-key") },
        }).then((res) => {
          if (
            res.data[0].auth === "viewOnly" &&
            !this.$store.getters.isAuthenticated
          ) {
            this.$store.commit(
              "SET_SNACKBAR",
              setSnackBarInfo("로그인이 필요합니다.")
            );
            clearLocalStorage();
            this.$router.replace("/login");
          }

          if (res.data.statusCode !== 500) {
            document.title = res.data[0].title;

            if (res.data[0].contents !== null) {
              this.link.description = res.data[0].contents.substring(0, 30);
            }

            this.link.title = res.data[0].title;
            this.link.url = "http://darrickrhee.com" + this.$route.fullPath;

            this.contents.id = res.data[0].id;
            this.contents.title = res.data[0].title;
            this.contents.contents = res.data[0].contents;
            this.contents.contentsHTML = res.data[0].contentsHTML;
            this.contents.auth = res.data[0].auth;
            this.contents.notice = res.data[0].notice;
            this.contents.editableUse = res.data[0].editableUse;
            this.contents.memberType = res.data[0].memberType;

            Nm.previous = res.data[0].previous;
            Nm.next = res.data[0].next;

            this.$store.commit("PREV_NEXT_NUM", Nm);

            this.contents.editable = false;
            this.contents.open = true;
            this.contents.isNew = false;
            this.contents.replyUse = true;
            this.contents.radioSelectedView = false;
            this.contents.sort = this.sort;

            this.$store.dispatch("SET_BULLETIN", this.contents).then(() => {
              this.editor.setContent(this.$store.getters.isContents);
              this.title = this.$store.getters.isTitle;
              this.checkRightClick();

              // 링크 클릭 이벤트 추가
              const editorContent = document.querySelector("#editorData");
              if (editorContent) {
                editorContent.addEventListener("click", (event) => {
                  const target = event.target;
                  if (target.tagName === "A" && !this.editable) {
                    event.preventDefault(); // 기본 링크 동작 방지
                    const href = target.getAttribute("href");
                    if (href) {
                      this.openLinkModal(href);
                    }
                  }
                });
              }
            });
          } else {
            this.$store.commit("SET_SNACKBAR", setSnackBarInfo("오류 발생."));
            this.$router.go(-1);
          }
          this.$store.commit("END_SPINNER");
        });
      } else if (this.id === "new" && this.sort) {
        this.$store.dispatch("CHECK_NEW_CONTENTS_MEMBERTYPE").then((res) => {
          if (res) {
            if (this.$store.getters.isRemained) {
              this.id = "";
              this.title = localStorage.getItem("title");
              this.editor.setContent(this.$store.getters.isContents);
            } else {
              this.id = "";
              this.title = "";
              this.editor.clearContent();
            }
            this.$store.commit("END_SPINNER");
            this.routine();
            this.checkRightClick();
          } else {
            this.$store.commit(
              "SET_SNACKBAR",
              setSnackBarInfo("권한조회 실패.")
            );
            this.$router.go(-1);
          }
        });
      } else {
        this.$store.commit("SET_SNACKBAR", setSnackBarInfo("권한이 없습니다."));
        this.$router.go(-1);
      }
    } catch (error) {
      this.$store.commit("SET_SNACKBAR", setSnackBarInfo("오류 발생."));
      this.$router.go(-1);
    }
    window.addEventListener("resize", this.updateModalSize);
  },
  created() {
    eventBus.$on("request-delete-detail", this.deleteDetail);
    eventBus.$on("request-save-detail", this.saveDetail);
    eventBus.$on("request-edit-detail-cancel", this.editDetailCancel);
    eventBus.$on("request-edit-detail", this.editDetail);
  },
  beforeDestroy() {
    eventBus.$off("request-delete-detail", this.deleteDetail);
    eventBus.$off("request-save-detail", this.saveDetail);
    eventBus.$off("request-edit-detail-cancel", this.editDetailCancel);
    eventBus.$off("request-edit-detail", this.editDetail);
    this.methodClearInterval();
    window.removeEventListener("resize", this.updateModalSize);
    document.body.removeAttribute("oncontextmenu");
    document.body.removeAttribute("onselectstart");
    document.body.removeAttribute("ondragstart");
  },
};
</script>

<style lang="scss">
.input-file-button {
  padding: 0;
}
.editor *.is-empty:nth-child(1)::before,
.editor *.is-empty:nth-child(2)::before {
  content: attr(data-empty-text);
  float: left;
  color: #aaa;
  pointer-events: none;
  height: 0;
  font-style: italic;
}
.editor {
  position: relative;
  margin: 0 auto 0rem;
  .menubar {
    text-align: left;
    border-bottom: 1px solid #ddd;
    padding: 0.2rem 0;
    transition: visibility 0.2s 0.4s, opacity 0.2s 0.4s;
    &.is-hidden {
      visibility: hidden;
      opacity: 0;
    }

    &.is-focused {
      visibility: visible;
      opacity: 1;
      transition: visibility 0.2s, opacity 0.2s;
    }

    &__button {
      font-weight: bold;
      display: inline-flex;
      background: transparent;
      border: 0;
      color: black;
      padding: 0.1rem;
      margin-right: 0.1rem;
      border-radius: 1px;
      cursor: pointer;

      &:hover {
        background-color: rgba(black, 0.05);
      }

      &.is-active {
        background-color: rgba(black, 0.1);
      }
    }

    span#{ &}__button {
      font-size: 13.3333px;
    }
  }
  .editor__content {
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    .ProseMirror {
      min-height: 15rem;
      margin-top: 1.5rem;
      padding: 0;
      &:focus {
        outline: none;
        background-color: white;
      }
      pre {
        padding: 0.7rem 1rem;
        border-radius: 5px;
        background: black;
        color: white;
        font-size: 0.8rem;
        overflow-x: auto;

        code {
          display: block;
        }
      }

      p code {
        padding: 0.2rem 0.4rem;
        border-radius: 5px;
        font-size: 15px;
        font-weight: bold;
        background: rgba(black, 0.1);
        color: rgba(black, 0.8);
      }

      ol,
      ul {
        padding-left: 1rem;
      }

      li > ol,
      li > p,
      li > ul {
        margin: 0;
      }

      a:not(.btn) {
        color: black;
        text-decoration: underline;
        cursor: pointer;
      }
      h1 {
        font-size: 30px;
      }
      h2 {
        font-size: 20px;
      }
      h3 {
        font-size: 15px;
      }
      p {
        font-size: 15px;
      }
      blockquote {
        border-left: 3px solid rgba(black, 0.1);
        color: rgba(black, 0.8);
        padding-left: 0.8rem;
        font-style: normal;
        p {
          margin: 0;
          font-size: 20px;
          font-weight: 300;
        }
      }

      img {
        max-width: 100%;
        border-radius: 3px;
      }

      table {
        border-collapse: collapse;
        table-layout: fixed;
        width: 100%;
        margin: 0;
        overflow: hidden;

        td,
        th {
          min-width: 1em;
          border: 2px solid grey;
          padding: 3px 5px;
          vertical-align: top;
          box-sizing: border-box;
          position: relative;
          > * {
            margin-bottom: 0;
          }
        }

        th {
          font-weight: bold;
          text-align: left;
        }

        .selectedCell:after {
          z-index: 2;
          position: absolute;
          content: "";
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background: rgba(200, 200, 255, 0.4);
          pointer-events: none;
        }

        .column-resize-handle {
          position: absolute;
          right: -2px;
          top: 0;
          bottom: 0;
          width: 4px;
          z-index: 20;
          background-color: #adf;
          pointer-events: none;
        }
      }

      .tableWrapper {
        margin: 1em 0;
        overflow-x: auto;
      }

      .resize-cursor {
        cursor: ew-resize;
        cursor: col-resize;
      }
    }
  }
}
.card .card-title {
  font-size: large;
  margin-top: 10px;
}
.card .card-body {
  background-color: white;
}
#editorTitle {
  padding-left: 20px;
  padding-right: 15px;
  background-color: white;
  color: black;
  padding: 20px;
  font-weight: 800;
  font-size: x-large;
  overflow: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#replyGroup {
  padding-bottom: 10px;
}
.container,
.container-fluid,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  padding: 0;
  padding-top: 10px;
}
#titleIcon {
  padding: 5px;
}
.v-sheet.v-app-bar.v-toolbar:not(.v-sheet--outlined) {
  min-height: 50px;
  max-height: 50px;
}
#titleCol {
  height: 60px;
}
.toolbarTitleDesktop {
  overflow: auto;
}
.toolbarTitleMobile {
  overflow: hidden;
}
hr.hr-1 {
  border: 0;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.75),
    rgba(0, 0, 0, 0)
  );
}
#replyRow {
  overflow: auto;
  white-space: inherit;
  flex-wrap: unset;
}
a.btn.btn-secondary.btn-block {
  color: white;
}
.kakao {
  height: 42px;
  border-radius: 10px;
}

/* 모달 스타일 (Home.vue에서 가져옴) */
.modal-header-draggable {
  cursor: move;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.modal-header-draggable h3 {
  margin: 0;
  font-size: 1.4rem;
}

.modal-header-draggable .close {
  font-size: 2rem;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.modal-header-draggable .close:hover {
  opacity: 0.8;
}

.modal-body {
  overflow-y: auto;
  height: calc(100% - 60px);
  padding: 20px;
}

.vmodal .resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 10px;
  height: 10px;
  cursor: se-resize;
}

.vmodal .resize-handle.top-right,
.vmodal .resize-handle.bottom-left,
.vmodal .resize-handle.top-left {
  display: none;
}

.modal-body::-webkit-scrollbar {
  width: 8px;
  display: block;
}

.modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: #555;
}

@media (max-width: 768px) {
  .modal-header-draggable h3 {
    font-size: 1.2rem;
  }
  .modal-body {
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .modal-header-draggable h3 {
    font-size: 1rem;
  }
}
</style>